import { render } from "./StorageAssignment.vue?vue&type=template&id=8d86b4a6&scoped=true"
import script from "./StorageAssignment.vue?vue&type=script&lang=js"
export * from "./StorageAssignment.vue?vue&type=script&lang=js"

import "./StorageAssignment.vue?vue&type=style&index=0&id=8d86b4a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d86b4a6"]])

export default __exports__